{
  "DATA_ASSISTANT": {
    "TITLE": "Βοηθός Δεδομένων",
    "NEW_CONVERSATION": "+ Νέα",
    "LOADING": "Φόρτωση...",
    "LOADING_MESSAGES": "Φόρτωση μηνυμάτων...",
    "THINKING": "Σκέψη...",
    "UNTITLED": "Συνομιλία χωρίς τίτλο",
    "NO_CONVERSATIONS": "Δεν υπάρχουν ακόμη συνομιλίες. Κάντε κλικ στο \"+ Νέα\" για να ξεκινήσετε.",
    "EMPTY_STATE": "Επιλέξτε μια συνομιλία ή δημιουργήστε μία νέα για να ξεκινήσετε.",
    "PLACEHOLDER": "Τι μπορώ να βρω για εσάς;",
    "SHOW_SQL": "Εμφάνιση SQL",
    "NO_ROWS": "Δεν επιστράφηκαν γραμμές.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Διαγραφή συνομιλίας",
    "DELETE_CONFIRM_DESCRIPTION": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη συνομιλία; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
    "DELETE_CONFIRM_YES": "Διαγραφή",
    "REPORTS": "Αναφορές",
    "SAVE_TO_REPORT": "Αποθήκευση σε αναφορά",
    "NEW_REPORT": "Νέα αναφορά",
    "REPORT_NAME": "Όνομα αναφοράς",
    "NO_REPORTS": "Δεν υπάρχουν ακόμη αποθηκευμένες αναφορές",
    "REPORTS_EMPTY_STATE": "Επιλέξτε μια αναφορά ή δημιουργήστε μία νέα.",
    "REPORT_SAVED": "Αποθηκεύτηκε στην αναφορά",
    "DELETE_REPORT_CONFIRM": "Διαγραφή αναφοράς",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την αναφορά; Όλα τα αποθηκευμένα στοιχεία θα αφαιρεθούν.",
    "DELETE_ITEM_CONFIRM": "Αφαίρεση στοιχείου",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Είστε σίγουροι ότι θέλετε να αφαιρέσετε αυτό το στοιχείο από την αναφορά;",
    "EXPORT_CSV": "Εξαγωγή CSV",
    "REFRESH": "Ανανέωση",
    "QUERY_RUNNING": "Εκτέλεση ερωτήματος...",
    "QUERY_FAILED": "Το ερώτημα απέτυχε",
    "AUTO_REFRESH": "Αυτόματη ανανέωση",
    "AUTO_REFRESH_NONE": "Χειροκίνητα",
    "AUTO_REFRESH_30S": "30 δευτερόλεπτα",
    "AUTO_REFRESH_1M": "1 λεπτό",
    "AUTO_REFRESH_5M": "5 λεπτά",
    "AUTO_REFRESH_10M": "10 λεπτά",
    "EDIT_MESSAGE": "Επεξεργασία μηνύματος",
    "RENAME_REPORT": "Μετονομασία αναφοράς",
    "RENAME_ITEM": "Μετονομασία στοιχείου",
    "MOVE_UP": "Μετακίνηση πάνω",
    "MOVE_DOWN": "Μετακίνηση κάτω",
    "COLLABORATORS": {
      "BUTTON": "Συνεργάτες",
      "TITLE": "Συνεργάτες αναφοράς",
      "DESCRIPTION": "Επιλέξτε ποιοι πράκτορες και ομάδες μπορούν να δουν αυτή την αναφορά.",
      "AGENTS": "Πράκτορες",
      "TEAMS": "Ομάδες",
      "SELECT_AGENTS": "Επιλογή πρακτόρων",
      "SELECT_TEAMS": "Επιλογή ομάδων",
      "SAVE": "Αποθήκευση",
      "SAVED": "Οι συνεργάτες ενημερώθηκαν",
      "SAVE_FAILED": "Αποτυχία ενημέρωσης συνεργατών"
    }
  }
}
